import { classNames } from "@/utils/classNames";
import { FloatingPortal } from "@floating-ui/react";
import { HTMLProps, ReactNode, useEffect } from "react";
import { toZIndex, ZLayer } from "./config";

let overlays = 0;

export type FloatingOverlayProps = {
  /** if true, put up a full "glass pane" that blocks interactions on elements in the background */
  modal?: boolean;
  layer?: ZLayer;
  children: ReactNode;
  onUnmount?: () => void;
} & HTMLProps<HTMLDivElement>;

export function FloatingOverlay({
  modal,
  layer,
  children,
  className,
  style,
  onUnmount,
  ...props
}: FloatingOverlayProps) {
  useEffect(() => {
    if (modal) {
      overlays++;
      document.body.classList.toggle("overflow-hidden", true);
      return () => {
        overlays = Math.max(0, overlays - 1);
        if (overlays === 0) {
          document.body.classList.remove("overflow-hidden");
        }
      };
    }
  }, [modal]);

  useEffect(() => {
    return onUnmount;
  }, [onUnmount]);

  return (
    <FloatingPortal>
      <div
        {...props}
        className={classNames(modal ? "fixed overflow-auto inset-0" : "relative", className)}
        style={{
          zIndex: layer ? toZIndex(layer) : undefined,
          ...style,
        }}
      >
        {children}
      </div>
    </FloatingPortal>
  );
}
